import { render, staticRenderFns } from "./WinTicket.vue?vue&type=template&id=1a0351ec"
import script from "./WinTicket.vue?vue&type=script&lang=js"
export * from "./WinTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports